module.exports = __webpack_public_path__ + "img/gtc.2d6895ce.svg";